import styled from 'styled-components'
import { usePage } from '../../contexts/PageProvider';
import SanityRegeneration from '../sanity/SanityRegeneration';
import SanityLuxury from '../sanity/SanityLuxury';
import SanityBuyback from '../sanity/SanityBuyback';
import SanityClub from '../sanity/SanityClub';

function PageFooter() {
  const page = usePage();

  if(page.footer == 'none') return <></>

  return (
      <Footer>
        { page.footer == 'regeneration' && <SanityRegeneration />}
        { page.footer == 'luxury' && <SanityLuxury />}
        { page.footer == 'buyback' && <SanityBuyback />}
        { page.footer == 'club' && <SanityClub />}
      </Footer>
  )
}

const Footer = styled.div`
  grid-column: 1 / -1;
  padding-bottom: var(--spacing-80);
`

export default PageFooter
